import { useUpdateUserProfile } from "@features/account/hooks/useUpdateUserProfile";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { EditUsernameDialog } from "@memorang/ui/components/AccountSettingsApplet/dialogs/EditUsernameDialog";
import { useMemo, useState } from "react";
import { useDialog } from "../DialogContext";
import type { DialogSpec } from "../types";

const EditUsernameDialogContainer = ({ onClose }: { onClose: () => void }) => {
	const { username } = useAuthContext();
	const { saveProfile } = useUpdateUserProfile();
	const [error, setError] = useState<string>();
	const [isSaving, setIsSaving] = useState(false);

	const handleSave = async (nextUsername: string) => {
		setError(undefined);
		setIsSaving(true);
		const result = await saveProfile({ username: nextUsername });
		setIsSaving(false);

		if (result.ok) {
			onClose();
			return;
		}

		setError(result.error);
	};

	return (
		<EditUsernameDialog
			visible
			onClose={onClose}
			initialUsername={username ?? ""}
			onSave={handleSave}
			isSaving={isSaving}
			error={error}
		/>
	);
};

export const editUsernameDialog: DialogSpec<"editUsername"> = {
	render: ({ onClose }) => <EditUsernameDialogContainer onClose={onClose} />,
};

export const useEditUsernameDialog = () => {
	const { showDialog, hideDialog } = useDialog();
	return useMemo(
		() => ({
			showEditUsername: () => showDialog("editUsername", {}),
			hideEditUsername: () => hideDialog("editUsername"),
		}),
		[showDialog, hideDialog],
	);
};
